import type { RailwayBucketCredentials } from '@cli-types/next-adapter/railway.js'
import type { CollectedIntegrationConfig } from '@cli-types/next-adapter/runtime.js'
import { RAILWAY_BUCKET_ENV_KEYS } from '@cli-constants/scaffolding.js'

export function railwayBucketIntegrationConfig(
  credentials: RailwayBucketCredentials
): CollectedIntegrationConfig {
  return {
    sections: [
      {
        header: 'Storage (Railway Bucket)',
        vars: [
          { key: 'BETTERSTART_RAILWAY_BUCKET_ENDPOINT', value: credentials.endpoint },
          {
            key: 'BETTERSTART_RAILWAY_BUCKET_ACCESS_KEY_ID',
            value: credentials.accessKeyId
          },
          {
            key: 'BETTERSTART_RAILWAY_BUCKET_SECRET_ACCESS_KEY',
            value: credentials.secretAccessKey
          },
          { key: 'BETTERSTART_RAILWAY_BUCKET_NAME', value: credentials.bucketName },
          { key: 'BETTERSTART_RAILWAY_BUCKET_REGION', value: credentials.region },
          { key: 'BETTERSTART_RAILWAY_BUCKET_URL_STYLE', value: credentials.urlStyle }
        ]
      }
    ],
    overwriteKeys: new Set(RAILWAY_BUCKET_ENV_KEYS)
  }
}
